import {marineHubAPI, RestQueryParams} from 'marine-panel-common-web';
import {Observable} from 'rxjs';

export function changeOperatorStatusAPI(authToken: string | null, operatorId: string, isActive: boolean): Observable<any> {
    const headers = {
            Authorization: `Bearer ${authToken}`,
        },
        payload = {
            active: isActive,
        };

    return marineHubAPI.put(`api/operators/${operatorId}/change_active`, payload, new RestQueryParams(), headers);
}
